export const merge = (a, b, collisionFn = (_, n) => n) => {
    const map = new Map();
    a.forEach((v, k) => {
        map.set(k, v);
    });
    b.forEach((v, k) => {
        const old = map.get(k);
        map.set(k, old === undefined ? v : collisionFn(old, v));
    });
    return map;
};
//# sourceMappingURL=map.js.map